import { observer } from 'mobx-react-lite'
import { TextInputContainer } from '@/components/inputs/TextInputContainer'
import { useFeatures } from '@/contexts/root-store-context'
import { RenameJobDialog } from '@/features/jobs/RenameJobDialog'
import { type RenameJobDialogViewModel } from './RenameJobDialogViewModel'

export interface RenameJobDialogContainerProps {
  vm: RenameJobDialogViewModel
}

export const RenameJobDialogContainer = observer(
  function RenameJobDialogContainer({ vm }: RenameJobDialogContainerProps) {
    const { shellInfo } = useFeatures(({ shell }) => ({
      shellInfo: shell.shellInfo,
    }))
    const testId = 'rename-job-modal'
    return (
      <RenameJobDialog
        showing={vm.modal.showing}
        corporateMode={shellInfo.corporateMode}
        isPending={vm.rename.pending}
        canSave={vm.nameHasChanged}
        onClose={vm.modal.close}
        onSubmit={vm.rename}
        confirmButtonTestId={`${testId}-confirm`}
      >
        <TextInputContainer
          autoFocus
          label="Name"
          data-test={`${testId}-new-name-input`}
          help="This will be visible to everyone"
          placeholder={vm.job.legendName}
          model={vm}
          isDisabled={vm.rename.pending}
          field="newName"
        />
      </RenameJobDialog>
    )
  },
)
